import classNames from "classnames";
import _ from "lodash";
import React, { useContext } from "react";
import ResizerHOC from "./../../ricos-common-plugins/resizable/react-resizer.js";
import { RicosContext } from "./../../ricos-context/RicosContext.js";
import { DraggableHOC } from "./../../_shared/draggable-hoc.js";
import { isNodeSelected } from "./../../_shared/is-node-selected.js";
import {
  getNodeWidth,
  getPluginContainerClassNames,
  getPluginFocusClassNames,
  getPluginPlacementClassNames
} from "./../../_shared/node-styles.js";
import { OverlayHoc } from "./../../_shared/overlay-hoc/overlay-hoc.js";
import { ButtonViewer } from "../viewer/button-viewer.js";
const createStylesHOC = (extraClassName) => (Component) => {
  return (props) => {
    const { isMobile } = useContext(RicosContext);
    const isTextWrapEnabled = props.extension.config.isTextWrap ?? true;
    const className = classNames(
      getPluginContainerClassNames(isMobile),
      getPluginPlacementClassNames(props.node, isTextWrapEnabled),
      extraClassName
    );
    const width = getNodeWidth(props.node, isMobile);
    const style = {
      width: width ? `min(100%, ${width}px)` : void 0
    };
    return /* @__PURE__ */ React.createElement("div", { className, style }, /* @__PURE__ */ React.createElement(Component, { ...props }));
  };
};
const ButtonResizerHOC = (Component) => {
  const ResizableComponent = ResizerHOC(Component);
  return (props) => {
    return props.extension.config.disableResize ? /* @__PURE__ */ React.createElement(Component, { ...props }) : /* @__PURE__ */ React.createElement(ResizableComponent, { ...props });
  };
};
const SelectionHOC = (Component) => {
  return (props) => {
    const isFocused = isNodeSelected(props.editor.state, props.node.attrs.id);
    const className = getPluginFocusClassNames(isFocused);
    return /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement(Component, { ...props }));
  };
};
const Button = _.flowRight(
  // We lift button margin to the plugin container so that resizer and selection are not affected
  createStylesHOC(),
  ButtonResizerHOC,
  DraggableHOC,
  SelectionHOC,
  OverlayHoc
)(({ componentData, settings, node }) => {
  return /* @__PURE__ */ React.createElement(
    ButtonViewer,
    {
      nodeId: node.attrs.id,
      buttonData: componentData,
      settings
    }
  );
});
export {
  Button
};
//# sourceMappingURL=component.js.map
